import { Pipe, PipeTransform } from '@angular/core';
import { UpdateAppointmentHistoryPlanning } from 'projects/Administration/src/app/business-entities/appointmentDetail-model';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';

@Pipe({
    name: 'StringToPlanningTablePipe'
})
export class StringToPlanningTablePipe implements PipeTransform {

    constructor(
    ) { 
      //this is intentional
    }

    transform(deatils: any): any {
        const arra =[]
        deatils.forEach(element => {
          if(element?.toString().includes(",")){
          let obj:UpdateAppointmentHistoryPlanning={
           duration:0,
           endDate:null,
           mechanic:'',
           startDate:null,
           date:null
          }
          let arr = element.split(",");
          if(arr && arr.length >0){
            obj.mechanic = arr[0];
            obj.startDate = Utility.ConvertUTCDateToLocalDate(arr[1]);
            obj.endDate = Utility.ConvertUTCDateToLocalDate(arr[2]);
            obj.duration = arr[3];
          }
          arra.push(obj);
        }
           
        })
        return arra;
        
    }
}


